import React, { useState } from 'react';
import { BiPencil, BiTrash } from 'react-icons/bi';
import { DefaultButton } from '../../../../components/Button/Button';
import { CreatingImage } from './CreatingImage';
import { ImageZoom } from '../ImageZoom/image';

export const ImageRegister = (props) => {
  const { onChange, values } = props;
  const [isCreating, setIsCreating] = useState(false);
  const [editingIndex, setEditingIndex] = useState(0);

  const handleDelete = (imageId) => {
    const updatedImages = values.entry_checklist.image_register.filter(
      (item) => item?.id !== imageId
    );

    onChange('entry_checklist', {
      image_register: updatedImages,
      fixed_checklist: values.entry_checklist.fixed_checklist,
    });
  };

  return (
    <div>
      <div className="os-entry-checklist-title-container">
        <h5 className="os-entry-checklist-title">Registro por imagem</h5>
        <DefaultButton
          className="modal-footer-button"
          label={'+ Adicionar imagem'}
          onClick={() => {
            setIsCreating(true);
            setEditingIndex(null);
          }}
        />
      </div>

      <div>
        {isCreating && (
          <CreatingImage
            setEditingIndex={setEditingIndex}
            editingIndex={editingIndex}
            values={values}
            onChange={onChange}
            setIsOpen={setIsCreating}
            isOpen={isCreating}
          />
        )}
        <div className="os-entry-checklist-image-mapper">
          {!values?.entry_checklist && (
            <span style={{ color: 'gray' }}>
              Nenhum registro por imagem foi feito até o momento
            </span>
          )}

          {values?.entry_checklist?.image_register?.map((image, index) => {
            return (
              <div
                key={`${image?.image}-${index}`}
                className="os-entry-checklist-image-container"
              >
                <div style={{ display: 'flex', gap: 10 }}>
                  <div>
                    <ImageZoom image={image?.image} />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginRight: 6,
                      marginTop: 6,
                    }}
                  >
                    <div
                      style={{ width: '100%' }}
                      className="os-entry-checklist-image-description"
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <span style={{ color: 'white' }}>
                          <span style={{ color: 'gray', fontWeight: 'bold' }}>
                            Peça:{' '}
                          </span>
                          {image?.piece?.label}
                        </span>

                        <div className="os-entry-checklist-image-actions">
                          <BiPencil
                            style={{ marginRight: 10 }}
                            onClick={() => {
                              setEditingIndex(index);
                              setIsCreating(true);
                            }}
                            className="os-entry-checklist-list-icon-style"
                          />

                          <BiTrash
                            onClick={() => handleDelete(image?.id)}
                            className="os-entry-checklist-list-icon-style"
                          />
                        </div>
                      </div>

                      <span style={{ color: 'white' }}>
                        <span style={{ color: 'gray', fontWeight: 'bold' }}>
                          Descrição:{' '}
                        </span>
                        {image?.description?.label}
                      </span>

                      <span style={{ color: 'white' }}>
                        <span style={{ color: 'gray', fontWeight: 'bold' }}>
                          Observações:{' '}
                        </span>
                        <span className="truncate">{image?.observation}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
